import { render } from "./VideosHome.vue?vue&type=template&id=3cd64909&scoped=true"
import script from "./VideosHome.vue?vue&type=script&lang=js"
export * from "./VideosHome.vue?vue&type=script&lang=js"

import "./VideosHome.vue?vue&type=style&index=0&id=3cd64909&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd64909"]])

export default __exports__